/**
 * BUG-0013 特殊费用默认费用归属分公司
 *
 * 规则：从订单上下文取，不再读跨会话 localStorage 记忆（specialChangeBranchId）。
 * - 订舱详情费用 tab：与普通新增费用一致——「其他结算公司」模式取 currentSettleBranchId，
 *   否则取 getBranchIdForCharge()（开 currentOfficeCharge 取 job.salesOffice，否则 job.opOffice）；
 * - 销售查询：取行数据的操作公司 opOffice，兜底当前登录公司。
 */

/**
 * 订舱详情费用 tab「新增特殊费用」默认分公司
 *
 * @param {Object} view 视图上下文（含 privilege.showOtherBranchCharge / currentSettleBranchId）
 * @param {Function} getBranchIdForCharge 返回订单上下文分公司（salesOffice/opOffice）
 * @returns {Number} 默认费用归属分公司 id
 */
export function resolveSpecialChargeBranchId(view, getBranchIdForCharge) {
  if (view && view.privilege && view.privilege.showOtherBranchCharge) {
    return view.currentSettleBranchId
  }
  return getBranchIdForCharge()
}

/**
 * 销售查询「特殊费用」默认分公司：取行数据的操作公司，兜底当前登录公司
 *
 * @param {Object} row 销售查询行数据（含 opOffice）
 * @param {Number} fallbackOfficeId 兜底公司 id（当前登录公司）
 * @returns {Number} 默认费用归属分公司 id
 */
export function resolveSalesSpecialChargeBranchId(row, fallbackOfficeId) {
  const opOffice = Number(row && row.opOffice)
  return opOffice > 0 ? opOffice : fallbackOfficeId
}
